module.exports = __webpack_public_path__ + "img/Hiyori2.7f8dc784.png";